var map = {
	"./bg0.png": 1573,
	"./bg1.png": 9948,
	"./bg2.png": 631,
	"./bg3.png": 4846,
	"./bg4.png": 9409,
	"./bg5.png": 1016,
	"./logo_bailac_l.png": 8331,
	"./logo_bailac_m.png": 7202,
	"./logo_bailac_s.png": 9452,
	"./logo_dark.png": 1774,
	"./logo_head.png": 7868,
	"./logo_light.png": 1056,
	"./picker-order.png": 8233,
	"./picker-popup.png": 9515,
	"./picker-user.png": 7544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;